import * as _ from 'lodash';
import { XLS_URL } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "ng-uikit-pro-standard";
export class FileDownloadService {
    constructor(toastService) {
        this.toastService = toastService;
        this.basePath = '';
        this.isDownloadingFile = false;
        this.basePath = XLS_URL;
    }
    VerifyAndDownload(rutaArchivo) {
        if (!rutaArchivo) {
            this.toastService.error('Error al generar archivo');
            return;
        }
        const url = `${this.basePath}/${rutaArchivo}`;
        this.isDownloadingFile = true;
        if (_.endsWith(rutaArchivo, 'pdf')) {
            window.open(url, '_blank');
        }
        else {
            document.location.href = url;
        }
        this.isDownloadingFile = false;
    }
    Download(rutaArchivo) {
        this.isDownloadingFile = true;
        document.location.href = `${this.basePath}/${rutaArchivo}`;
        this.isDownloadingFile = false;
    }
    DownloadPDF(rutaArchivo) {
        this.isDownloadingFile = true;
        if (rutaArchivo)
            window.open(`${this.basePath}/${rutaArchivo}`);
        else
            this.toastService.error('Error al generar archivo');
        this.isDownloadingFile = false;
    }
}
FileDownloadService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FileDownloadService_Factory() { return new FileDownloadService(i0.ɵɵinject(i1.ToastService)); }, token: FileDownloadService, providedIn: "root" });
